import {gql} from "@apollo/client";

export const SDNO_DAAP_SAVE_SUBSCRIPTION_MUTATION = gql`
    mutation sdnoDaapUpdateSubscription(
        $deletedGeographies: [SdnoDaapGeographySubscription!]!
        $deletedSubcategories: [SdnoDaapSubcategorySubscription!]!
        $geographies: [SdnoDaapGeographySubscription!]!
        $subcategories: [SdnoDaapSubcategorySubscription!]!
    ) {
        sdnoDaapUpdateSubscription(
            deletedGeographies: $deletedGeographies
            deletedSubcategories: $deletedSubcategories
            geographies: $geographies
            subcategories: $subcategories
        ) {
            message
            success
        }
    }
`;

export const SDNO_DAAP_SAVE_DISTRIBUTOR_PLATFORM_SUBSCRIPTION_MUTATION = gql`
    mutation sdnoDaapUpdateDistributorPlatformSubscription(
        $distributorPlatform: [SdnoDaapDistributorPlatformSubscription!]!
        $deletedDistributorPlatform: [SdnoDaapDistributorPlatformSubscription!]!
    ) {
        sdnoDaapUpdateDistributorPlatformSubscription(
            distributorPlatform: $distributorPlatform
            deletedDistributorPlatform: $deletedDistributorPlatform
        ) {
            message
            success
        }
    }
`;
